<template>
  <v-flex shrink>
    <v-btn
      color="sz_violet"
      class="mx-0"
      @click="showDialog()"
    >
      <v-icon>add</v-icon>
      {{ buttonTitle }}
    </v-btn>
    <AddWarehouseDialog
      :title="dialogTitle"
      :visible="isDialogVisible"
      :warehouse-type="warehouseType"
      @close="isDialogVisible = $event"
    />
  </v-flex>
</template>

<script>
import AddWarehouseDialog from '@/components/widgets/warehouse/AddWarehouseDialog';
import WAREHOUSE_TYPE from '@/constants/warehouse/warehouseType';
export default {
    name: 'AddWarehouseButton',
    components: {
        AddWarehouseDialog
    },
    props: {
        warehouseType: {
            required: true,
            type: Number
        }
    },
    data () {
        return {
            isDialogVisible: false,
            WAREHOUSE_TYPE
        };
    },
    computed: {
        regionalWarehouse () {
            return this.warehouseType === this.WAREHOUSE_TYPE.REGIONAL;
        },
        dialogTitle () {
            return this.regionalWarehouse
                ? this.$t('warehouses.add_rejon_warehouse.dialog.title')
                : this.$t('warehouses.add_supporting_warehouse.dialog.title');
        },
        buttonTitle () {
            return this.regionalWarehouse
                ? this.$t('buttons.add_rejon_warehouse')
                : this.$t('buttons.add_supporting_warehouse');
        }
    },
    methods: {
        showDialog () {
            this.isDialogVisible = true;
        }
    }
};
</script>

<style scoped></style>
